import {logErrorToSentry} from "../../utils/errors/logErrorToSentry";
import type {AppState} from "@stores/AppState";
import { IAuthService } from "../../platform/services/auth/AuthService";

import {undoManager} from "../common/UndoManager";
import {HOTKEYS_SCOPE, setScope} from "../../utils/hotkeys";


export const logout = async (appState: AppState, authService: IAuthService) => {
    try {
        await authService.signOut();
    } catch (error: unknown) {
        logErrorToSentry(error as any);
    }
    appState.resetState();
    undoManager.resetState();
    setScope(HOTKEYS_SCOPE.UNAUTHORIZED);
}
